export let DisplayMode;
(function (DisplayMode) {
  DisplayMode["SELECT"] = "SELECT";
  DisplayMode["ADD"] = "ADD";
  DisplayMode["EDIT"] = "EDIT";
})(DisplayMode || (DisplayMode = {}));